import { keyBy } from 'lodash';
import { useMemo } from 'react';
import { UrlContext } from '../../utils/UrlContext';
import { GigData } from '../../server/types/GigData';

export const useRelevantGigs = (gigs: GigData[] = [] as GigData[]) =>
    useMemo(() => {
        const urlGigParams = UrlContext.getUrlGigs();
        const urlGigRefSlug = UrlContext.getRefGigSlug();
        if (urlGigRefSlug) {
            urlGigParams.push(urlGigRefSlug);
        }

        const gigsMap = keyBy(urlGigParams, (item) => item.id || item.slug);
        return gigs.filter((gig) => gigsMap[gig.gig_id] || gigsMap[gig.cached_slug]);
    }, [gigs]);
